import withLocalLoader from 'components/HOCs/withLocalLoader';
import CallReviewsPage from './CallReviewsPage';

export default withLocalLoader(CallReviewsPage, true, 'Call Reviews');
